import { KEYCLOAK_TOKEN_REFRESH, KEYCLOAK_TOKEN_REFRESHED, doWebsocketAuth } from 'app/store/users';
import { FOREIGN_HTTP_ERROR } from 'app/store/error/types';
import { refreshJwtToken } from 'app/store/auth';
import { apiClient } from './utils.js';

export const clientWrapper = (dispatch, params) =>
    new Promise((resolve, reject) => {
        refreshJwtToken({
            onSuccess: (token) => {
                if (token) {
                    dispatch({ type: KEYCLOAK_TOKEN_REFRESHED });
                    dispatch(doWebsocketAuth(token));
                }

                const client = apiClient(params)
                    .onSuccess(resolve)
                    .onError(reject)
                    .onForeignError((error) => {
                        console.error('snowflakeQueryMiddleware: foreign error', error);
                        dispatch({ type: FOREIGN_HTTP_ERROR, payload: error });
                        reject(error);
                    });

                client();
            },
            onError: (e) => {
                console.error('snowflakeQueryMiddleware: error refreshing JWT token', e);
                dispatch({ type: KEYCLOAK_TOKEN_REFRESH.FAILED });
                reject(e);
            }
        });
    });
